module.exports = __webpack_public_path__ + "55e062a147013479aa41b2bdf3d38bea.pdf";